import http from "../http-common";
const getAll = () => {
  return http.get("/users");
};

export const UserService = {
  getAll
};
